import React, { useState } from "react";

const LogoutBgIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseHover = (state) => setIsHovered(state);

  const fillColor = isActive ? "#1D4469" : isHovered ? "#1D4469" : "#969BA9";
  const backgroundColor = isActive ? "#EBF2F7" : "";

  return (
    <span onMouseEnter={() => handleMouseHover(true)} onMouseLeave={() => handleMouseHover(false)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.25"
          y="0.25"
          width="23.5"
          height="23.5"
          rx="2.35"
          fill={backgroundColor}
          stroke={isActive ? "#C2D0DA" : ""}
          strokeWidth="0.5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.8993 16.7702V17.4679C11.8993 18.0274 11.6205 18.5105 11.1359 18.7902C10.9028 18.9248 10.6426 18.9999 10.3728 19C10.1028 19.0001 9.84266 18.9249 9.60937 18.7902L6.50706 16.9991C6.02245 16.7193 5.74365 16.2364 5.74365 15.6768V6.52682C5.74365 5.68488 6.42856 5 7.27047 5H14.1029C14.9448 5 15.6298 5.68482 15.6298 6.52682V8.45561C15.6298 8.73231 15.4051 8.95696 15.1284 8.95696C14.8517 8.95696 14.6272 8.73233 14.6272 8.45561V6.52682C14.6272 6.23771 14.392 6.00247 14.1029 6.00247H8.11591L11.1359 7.74637C11.6203 8.0261 11.8993 8.50899 11.8993 9.06836V15.7676H14.1029C14.3919 15.7676 14.6272 15.5325 14.6272 15.2434V13.5526C14.6272 13.2757 14.8515 13.0512 15.1284 13.0512C15.4052 13.0512 15.6298 13.2758 15.6298 13.5526V15.2434C15.6298 16.0854 14.9448 16.7702 14.1029 16.7702H11.8993ZM16.5445 11.3863L15.9925 11.9384C15.7967 12.1342 15.7968 12.4515 15.9925 12.6473C16.0867 12.7416 16.2137 12.794 16.3469 12.794C16.4803 12.794 16.6071 12.7417 16.7015 12.6473L18.1091 11.2394C18.3048 11.0437 18.3049 10.7265 18.1091 10.5308L16.7015 9.12316C16.5057 8.92738 16.1883 8.92746 15.9925 9.12313C15.7968 9.31869 15.7968 9.63618 15.9925 9.8318L16.5445 10.3838H12.846C12.5691 10.3838 12.3448 10.6082 12.3448 10.8851C12.3448 11.1621 12.5691 11.3864 12.846 11.3864H16.5445V11.3863Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default LogoutBgIcon;
